module.exports = __webpack_public_path__ + "static/media/issue9_cover.95404978.png";